/** The brandbook's thousands separator: a thin space, never a comma or a dot. */
const THIN_SPACE = '\u2009';

/**
 * A count for a heading, a chip or a "N of M" line (spec 226 edge case): whole
 * digits grouped by three with a thin space — "1 204" — so a four-digit count
 * is read as one number and never truncated. Below a thousand it is the bare
 * digits.
 */
export function formatCount(n: number): string {
  const whole = Math.trunc(Math.abs(n));
  const digits = String(whole);
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, THIN_SPACE);
  return n < 0 ? `-${grouped}` : grouped;
}
